import { AppReducer } from './app-reducer';
import { InitialState } from '../state';

export const registrationReducer: AppReducer<'Registration'> = (
    state = InitialState.Registration,
    action
): typeof state => {
    switch (action.type) {
        case 'Registration/RegisterUser/Started':
            return {
                ...state,
                loading: true,
                success: false,
            };

        case 'Registration/RegisterUser/Succeeded':
            return {
                ...state,
                loading: false,
                success: true,
                email: action.payload.email,
                organizationName: action.payload.organizationName,
            };

        case 'Registration/RegisterUser/Failed':
            return {
                ...state,
                loading: false,
                success: false,
                errorCode: action.payload.errorCode,
            };

        case 'Registration/LoadEula/Started':
            return {
                ...state,
                eulaLoading: true,
                eula: '',
            };
        case 'Registration/LoadEula/Succeeded':
            return {
                ...state,
                eulaLoading: false,
                eula: action.payload.content,
            };
        case 'Registration/LoadEula/Failed':
            return {
                ...state,
                eulaLoading: false,
                eula: '',
            };

        case 'Registration/ValidateUser/Started':
            return {
                ...state,
                validationloading: true,
                validationSuccess: false,
            };

        case 'Registration/ValidateUser/Succeeded':
            return {
                ...state,
                validationloading: false,
                validationSuccess: true,
                firstName: action.payload.fname,
                lastName: action.payload.lname,
                phone: action.payload.phone,
                existingUser:
                    action.payload.fname !== undefined ||
                    action.payload.lname !== undefined ||
                    action.payload.fname === null ||
                    action.payload.lname === null
                        ? true
                        : false,
            };

        case 'Registration/ValidateUser/Failed':
            return {
                ...state,
                validationloading: false,
                validationSuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'Registration/InviteUser/Started':
            return {
                ...state,
                inviteUserLoading: true,
                inviteUserSuccess: false,
                errorCode: '',
            };

        case 'Registration/InviteUser/Succeeded':
            return {
                ...state,
                inviteUserLoading: false,
                inviteUserSuccess: true,
                errorCode: '',
            };

        case 'Registration/InviteUser/Failed':
            return {
                ...state,
                inviteUserLoading: false,
                inviteUserSuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'Registration/InviteUser/Unmounted':
            return {
                ...state,
                inviteUserLoading: false,
                inviteUserSuccess: false,
                errorCode: '',
            };
        case 'Registration/deleteUser/Started':
            return {
                ...state,
                deleteUserLoading: true,
                deleteUserSuccess: false,
                errorCode: '',
            };
        case 'Registration/deleteUser/Succeeded':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: true,
                errorCode: '',
            };
        case 'Registration/deleteUser/Failed':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: false,
                errorCode: action.payload.errorCode,
            };
        case 'Registration/deleteUser/Unmounted':
            return {
                ...state,
                deleteUserLoading: false,
                deleteUserSuccess: false,
                errorCode: '',
            };

        default:
            return state;
    }
};
